export default __webpack_public_path__ + "static/media/dropdown-default-vs-split-default.3890cef3.svg";